import { Box, Flex } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';

export function ActionCardFooter() {
  return (
    <Flex gap={4} align="center" w="100%" mt="md">
      <Box
        flex={1}
        h={36}
        style={{
          border: '4px solid white',
          borderRadius: 50,
        }}
      />
      <Box
        w={20}
        h={36}
        style={{
          border: '4px solid white',
          borderRadius: 50,
          flexShrink: 0,
        }}
      />
      <Flex
        w={48}
        h={36}
        align="center"
        justify="center"
        style={{
          border: '4px solid white',
          borderRadius: 50,
          flexShrink: 0,
        }}
      >
        <IconArrowRight size={16} color="white" />
      </Flex>
    </Flex>
  );
}
